<template>
  <div class="main">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>
    <selectTool ref="selectTool"
      ><template slot="btn"
        ><Button @click="getSearchItem" type="error" class="chaxun"
          >查询</Button
        ></template
      ></selectTool
    >

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <AddressList
        slot-scope="{ row, index }"
        slot="addressS"
        :list="row.addressS"
        :readonly="true"
        :noUpdate="true"
      ></AddressList>
      <AddressList
        slot-scope="{ row, index }"
        slot="addressD"
        :list="row.addressD"
        :readonly="true"
        :noUpdate="true"
      ></AddressList>
      <template slot-scope="{ row, index }" slot="signFilesArr">
        <viewer v-if="row.signFilesArr">
          <img
            v-for="(x, index) in row.signFilesArr"
            :key="index"
            :src="axios.platConfig.fileUri + x"
            width="24"
            height="24"
            style="margin-right: 4px; cursor: pointer"
          />
        </viewer>
      </template>
      <template slot-scope="{ row, index }" slot="action">
  
        <Button size="small" @click="$refs.jiedian.reach(row.ono)">进程</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model
      :title="isAdd ? '新增数据' : '编辑数据'"
      width="1000"
      ref="formModel"
    >
      <alot-item
        @on-click="openForm = true"
        slot="ono"
        v-model="item.listOrders"
        keyw="ono"
        style="min-height: 30px"
      ></alot-item>

      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
    <form-model title="更新提货状态" width="400" ref="updateStatus">
      <Button slot="btn" type="primary" @click="updateStatus">提交表单</Button>
    </form-model>
    <form-model title="更新调度状态" width="400" ref="updateDispatchStatus">
      <Button slot="btn" type="primary" @click="updateDispatchStatus"
        >提交表单</Button
      >
    </form-model>
    <Modal
      v-model="openForm"
      fullscreen
      title="订单号"
      footer-hide
      width="1000"
    >
      <dingdanhao
        :scan="true"
        :checkMore="true"
        :status="[]"
        @objs="reObj"
        :col="col"
        v-if="openForm"
      ></dingdanhao>
    </Modal>
    <jiedian ref="jiedian"></jiedian>
     
  </div>
</template>
<script>
var ordes = [];
//pickupTime
import dingdanhao from "./xitongkaidanSort.vue";

var list1 = [],
  list2 = [];
export default {
  components: { dingdanhao },
  data() {
    return {
      isAdd: false,
      openForm: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
          sort: 0,
        },
        {
          title: "调度单号",
          key: "no",
          sort: 1.1,
        },
        {
          title: "附件资料",
          slot: "signFilesArr",
          sort: 6.1,
        },
        {
          title: "调度状态",
          key: "dispatchStatus2", //0--/待提货 1--已调度
          sort: 1.1,
        },
        {
          title: "操作",
          slot: "action",
          width: 150,
          sort: 100,
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        xd: 0,
        xs: 0,
        yd: 0,
        ys: 0,
        groupId: "",
        groupName: "",
        no: "",
        listOrders: [],
        carNo: "",
        bpMode: 1,
        driverAccount: "",
        driver: "",
        addressS: [],
        timeS: Date.now(),
        timesUnload: Date.now() + 3600000 * 2,
        addressD: [],
        remark: "",
        //extendFields: "",
      },
      forms: [
        /* {
          title: "提货单号",
          key: "no",
          required: false,
          type: "Select",
          selectItems: ["HS202305061112"],
        }, */
        {
          title: "订单号",
          key: "listOrders",
          key2: "listOrders2",
          slotForm: "ono",
          required: true,
          span: 24,
        },
        {
          title: "业务类型",
          key: "bpMode",
          key2: "bpMode2",
          required: true,
          type: "Select",
          selectType: "obj",
          selectItems: this.lydic["bpMode"],
          span: 8,
        },
        {
          title: "大陆车牌",
          key: "carId",
          key1: "carNo",
          required: false,
          type: "selectCar",
          span: 8,
        },
        {
          title: "司机",
          key4: "driverAccount",
          key1: "driver",
          //key3: "driverAccount",
          required: false,
          type: "selectUser",
          span: 8,
        },
{
          title: "香港车牌",
          key: "carId",
          key1: "carNoHk",
          required: false,
          type: "selectCar",
          span: 8,
        },
         {
          title: "香港司机",
          key4: "driverAccountHk",
          key1: "driverHk",
          //key3: "driverAccount",
          required: false,
          type: "selectUser",
          span: 6,
          keyword: "司机",
        },
        {
          title: "提货地点",
          key: "addressS",
          keyX: "xs",
          keyY: "ys",
          slot: "addressS",
          required: true,
          readonly: false,
          noUpdate: true,
          width: 300,
          type: "AddressList",
          span: 8,
          list1,
          list2,
        },
        {
          title: "卸货地点",
          key: "addressD",
          slot: "addressD",
          keyX: "xd",
          keyY: "yd",
          width: 300,
          required: true,
          readonly: false,
          noUpdate: true,
          type: "AddressList",
          span: 8,
          list1,
          list2,
        },
        {
          title: "提货时间",
          key: "timeS",
          key2: "timeS2",
          required: true,
          type: "lyyymmdd",
          formate: "datetime",
          span: 8,
        },
        {
          title: "卸货时间",
          key: "timesUnload",
          key2: "timesUnload2",
          required: true,
          type: "lyyymmdd",
          formate: "datetime",
          span: 8,
        },

        {
          title: "装货到场时间",
          key: "timesLoadArrive",
          key2: "timesLoadArrive2",
          type: "lyyymmdd",
          formate: "datetime",
          span: 8,
        },
        {
          title: "装货离开时间",
          key: "timesLoadLeave",
          key2: "timesLoadLeave2",
          type: "lyyymmdd",
          formate: "datetime",
          span: 8,
        },
        {
          title: "卸货到场时间",
          key: "timesUnloadArrive",
          key2: "timesUnloadArrive2",
          type: "lyyymmdd",
          formate: "datetime",
          span: 8,
        },
        {
          title: "卸货离开时间",
          key: "timesUnloadLeave",
          key2: "timesUnloadLeave2",
          type: "lyyymmdd",
          formate: "datetime",
          span: 8,
        },
        {
          title: "备注",
          key: "remark",
          required: false,
          type: "Input",
          span: 8,
        },
      ],
      updateStatusItem: {
        status: 0,
        no: "",
      },
      updateStatusForms: [
        {
          title: "提货状态",
          key: "status",
          type: "Select1",
          st: "rucang",
          required: true,
        },
      ],
      updateDispatchStatusItem: {
        no: "",
        dispatchStatus: "",
      },
      updateDispatchStatusForms: [
        {
          title: "调度状态",
          key: "dispatchStatus",
          type: "Select",
          selectType: "obj",
          selectItems: this.lydic["dispatchStatus"],
          required: true,
        },
      ],
      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
      },
      total: 0,

      searchForms: [
        {
          title: "六联单号",
          key: "sixOno",
          type: "Input",
        },
        {
          title: "订单号",
          key: "ono",
          type: "Input",
        },
        {
          title: "运单号",
          key: "tno",
          type: "Input",
        },
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          required: true,
          val: 0,
          type: "lyyymmdd",
          times: "4,2,0",
        },
      ],
      col: [
        {
          title: "提货地址",
          slot: "pickupAddress",
          width: 300,
        },
        {
          title: "卸货地址",
          slot: "unloadAddress",
          width: 300,
        },
        {
          title: "进出口岸",
          key: "customs",
        },
        {
          title: "始发地",
          key: "addressS",
        },
        {
          title: "目的地",
          key: "addressD",
        },
      ],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        //url: this.axios.ipPort + "/cloud-tms-server-ctc/pickup/list",
        url: this.axios.ipPort + "/cloud-tms-server-ctc/pickup/listFinish",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].dispatchStatus2 = this.lydic.getVal(
            "dispatchStatus",
            data[i].dispatchStatus
          );
          //data[i].status2 = this.$t("rucang." + data[i].status);
          data[i].timeS2 = this.utils.time(data[i].timeS, "yymmddhhmm");
          data[i].timesUnload2 = this.utils.time(
            data[i].timesUnload,
            "yymmddhhmm"
          );
          data[i].timesLoadArrive2 = this.utils.time(
            data[i].timesLoadArrive,
            "yymmddhhmm"
          );
          data[i].timesLoadLeave2 = this.utils.time(
            data[i].timesLoadLeave,
            "yymmddhhmm"
          );
          data[i].timesUnloadArrive2 = this.utils.time(
            data[i].timesUnloadArrive,
            "yymmddhhmm"
          );
          data[i].timesUnloadLeave2 = this.utils.time(
            data[i].timesUnloadLeave,
            "yymmddhhmm"
          );
          data[i].listOrders2 = ordes(data[i].listOrders);
          data[i].bpMode2 = this.lydic.getVal("bpMode", data[i].bpMode);
           data[i].signFilesArr = this.utils.isEmpty(data[i].signFiles)
            ? []
            : JSON.parse(data[i].signFiles);
        }
        this.tableData = data;
        console.log(data);
        function ordes(t) {
          var arr = [];
          for (let i = 0; i < t.length; i++) {
            arr.push(t[i].ono);
          }

          return arr.join(",");
        }
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      console.log(a);
      this.item = a;
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-ctc/pickup/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-ctc/pickup/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },

    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-tms-server-ctc/pickup/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openUpdateStatus(row) {
      this.updateStatusItem.no = row.no;
      this.updateStatusItem.status = row.status;
      this.$refs.updateStatus.reach(
        this.updateStatusForms,
        this.updateStatusItem
      );
    },
    updateStatus(name) {
      var a = this.$refs.updateStatus.getItem();

      if (!a) {
        return;
      }
      this.updateStatusItem = a;
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-ctc/pickup/updateStatus",
        data: this.updateStatusItem,
      }).then((res) => {
        if (res) {
          this.$refs.updateStatus.close();
          this.getList();
        }
      });
    },
    openUpdateDispatchStatus(row) {
      this.updateDispatchStatusItem.no = row.no;
      this.updateDispatchStatusItem.dispatchStatus = row.dispatchStatus;
      this.$refs.updateDispatchStatus.reach(
        this.updateDispatchStatusForms,
        this.updateDispatchStatusItem
      );
    },
    updateDispatchStatus(name) {
      var a = this.$refs.updateStatus.getItem();

      if (!a) {
        return;
      }
      this.updateStatusItem = a;
      this.axios({
        method: "post",
        url:
          this.axios.ipPort +
          "/cloud-tms-server-ctc/pickup/updateDispatchStatus",
        data: this.updateDispatchStatusItem,
      }).then((res) => {
        if (res) {
          this.$refs.updateDispatchStatus.close();
          this.getList();
        }
      });
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    //carTypeCategory
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
    reObj(v) {
      this.openForm = false;
      //this.item.listOrders = [];

      this.item.listOrders = [];
      this.item.addressS = [];
      this.item.addressD = [];

      for (let i = 0; i < v.length; i++) {
        this.item.listOrders.push({ ono: v[i].no });

        var t = v[i].pickupAddress;
        for (let j = 0; j < t.length; j++) {
          this.item.addressS.push(t[j]);
        }
        var t = v[i].unloadAddress;
        for (let j = 0; j < t.length; j++) {
          this.item.addressD.push(t[j]);
        }
      }
      var arr = this.item.addressS;
      this.item.addressS = arr.filter(
        (item, index) => arr.findIndex((i) => i.x === item.x) === index
      );
      var arr = this.item.addressD;
      this.item.addressD = arr.filter(
        (item, index) => arr.findIndex((i) => i.x === item.x) === index
      );
      if (v.length > 0) {
        this.item.cid = v[0].cid;
        this.getKehuItem();
      }
      return;
      var t = v[0];
      if (t.isFdpz === 0) {
        //console.log(v[0].ordersGoodsList[0].pickupAddress);

        this.item.timeS = v[0].ordersGoodsList[0].pickupTime;
        this.item.addressS = v[0].ordersGoodsList[0].pickupAddress;
      } else {
        this.item.timeS = v[0].shipmentTime;
        this.item.addressS = v[0].pickupAddress;
      }
    },
    getKehuItem() {
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-base/customer/info",
        data: { id: this.item.cid },
      }).then((res) => {
        console.log(res);
        var pickupAddressList = res.data.data.pickupAddressList;
        var shippingAddressList = res.data.data.shippingAddressList;
        list1.splice(0, 1000);
        list2.splice(0, 1000);
        for (let i = 0; i < pickupAddressList.length; i++) {
          var add = pickupAddressList[i].address.split("_");

          var obj = {
            name: add[0],
            address: add[1],
            x: pickupAddressList[i].x,
            y: pickupAddressList[i].y,
          };
          list1.push(obj);
        }
        for (let i = 0; i < shippingAddressList.length; i++) {
          var add = shippingAddressList[i].address.split("_");
          var obj = {
            name: add[0],
            address: add[1],
            x: shippingAddressList[i].x,
            y: shippingAddressList[i].y,
          };
          list2.push(obj);
        }
      });
    },
    
  },
  mounted() {
    var config = {
      min: 130,
      max: 300,
    };
    this.columns = this.utils.cols(this.forms, this.columns, config);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 300);
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/wuliu/fahuo/diaoduwancheng.vue